import { useEffect, useState } from "react";
import { apiFetch } from "@/lib/api";
import { getBranding } from "@/lib/theme";

/**
 * Hồ sơ doanh nghiệp dùng chung với bản máy tính.
 *
 * Cùng một bản ghi trong cơ sở dữ liệu, nên đổi tên hay logo ở trang Cài đặt là
 * bản điện thoại đổi theo, không phải build lại.
 */
export interface Company {
  name: string;
  shortName: string;
  logoUrl: string | null;
  themeColor: string;
  address: string;
  taxCode: string;
  /** Kho mặc định khai ở phần Cài đặt trên bản máy tính. */
  defaultWarehouseId: string;
  defaultWarehouseName: string;
}

/**
 * Vỏ trang đã nhúng sẵn phần nhận diện nên có ngay, kể cả trước khi đăng nhập.
 * Địa chỉ và mã số thuế chỉ lấy được sau khi đăng nhập, nên để trống ban đầu.
 */
const FALLBACK: Company = {
  ...getBranding(),
  address: "",
  taxCode: "",
  defaultWarehouseId: "",
  defaultWarehouseName: "",
};

/** Đọc một lần rồi giữ lại: hồ sơ hiếm khi đổi trong một phiên làm việc. */
let cached: Company | null = null;

export function useCompany(token?: string | null): Company {
  const [company, setCompany] = useState<Company>(cached ?? FALLBACK);

  useEffect(() => {
    if (cached) return;

    let cancelled = false;

    void (async () => {
      try {
        const res = await apiFetch<{ data: Partial<Company> }>(
          "/company-profile",
          {},
          token ?? undefined,
        );

        if (cancelled) return;

        cached = { ...FALLBACK, ...(res.data ?? {}) };
        setCompany(cached);
      } catch {
        // Không lấy được thì dùng mặc định — không chặn việc nhận hàng.
      }
    })();

    return () => { cancelled = true; };
  }, [token]);

  return company;
}
